import { idURL, kadhavuExpUrl } from 'endpoints';
import { endLoading, setError, startLoading } from './app-dux';
import { setLoggedInPersonDetails } from './password-dux';
import { routeHistory } from '@nackle/biw-web-router';
import { getAccountBalance, getAccountInfo } from '../cashier-api';
import { getUserMarketplace } from '../piers-api';
import { PASSWORD_REPEAT_LIMIT } from '../constants';
import { fetch } from '@nackle/umbrella';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    id: null,
    error: ''
};

/*******************************************************************************
 * Non-async action types
 */
export const SET_INTERACTION = 'interaction/set_interaction';
export const SET_ERROR = 'interactions/set_error';

/*******************************************************************************
 * Reducer
 */
export default function interactionReducer( state = initialState, action ) {
    switch ( action.type ) {
        case SET_INTERACTION:
            return {
                ...state,
                id: action.id
            };

        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
export function setInteraction( id ) {
    return {
        type: SET_INTERACTION,
        id
    };
}

export const getPrimaryExperienceUrl = () => async( dispatch, getState ) => {
    try {
        dispatch( startLoading() );

        const res = await fetch( `${ kadhavuExpUrl }/getPrimaryExperience`, {
            method: 'GET',
            headers: { 'content-type': 'application/json' }
        } );

        const data = await res.json();

        if ( data.errors ) {
            throw data.errors;
        }

        if ( data && data.url ) {
            return data.url;
        } else {
            dispatch( setError( [ { code: 'errors.content.generic' } ] ) );
        }
    } finally {
        dispatch( endLoading() );
    }
};

const handleInactiveTerminatedUser = async ( data, companyId, dispatch ) => {
    const errorDetails =  data?.error_details;
    const accessToken = errorDetails?.accessToken;
    const externalId = errorDetails?.person?.externalId;
    const accountData = await getAccountInfo( accessToken, externalId, companyId );
    if ( !accountData.accountNumber ) {
        dispatch( setError( [ { code: 'kadhavu.error.terminatedWithNoPoints' } ] ) );
    } else {
        const marketPlaceData = await getUserMarketplace( accessToken, companyId, errorDetails?.person?.id );
        const person = marketPlaceData.data?.person;
        const marketplace = person.marketplace;
        if ( !marketplace ) {
            routeHistory.push( '/door/error' );
            return;
        }
        const pointsData = await getAccountBalance( accessToken, externalId, companyId );
        if ( pointsData.accountBalance === 0 ) {
            dispatch( setError( [ { code: 'kadhavu.error.terminatedWithNoPoints' } ] ) );
        } else {
            routeHistory.push( '/door/inactive', {
                accessToken,
                person: errorDetails.person,
                menuItems: marketplace?.menuItems,
                solutionIdentity: person.solutions[ 0 ].solutionIdentity
            } );
        }
    }
};

export function login( username, password, companyId, idUrl ) {

    return ( dispatch, getState ) => {
        dispatch( startLoading() );

        const state = getState();

        const id = ( state.interaction && state.interaction.id ) ? state.interaction.id : sessionStorage.getItem( 'interactionId' );

        const locale = state.app.userSelectedLocale || '';

        // idUrl is passed from DMSA only for host transfer to if that's getting passed we need to take that into account as the autority is built for that instead of taking it from endpoints
        return fetch( `${ idUrl ? idUrl : idURL }/interaction/${ id }/submit`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify( { username, password, locale } )
        } ).then( async ( response ) => {
            if ( response.headers.get( 'Content-Type' ).indexOf( 'text/html' ) >= 0 ) {
                sessionStorage.clear();
                const primaryExperienceUrl = await dispatch( getPrimaryExperienceUrl() );
                window.location = primaryExperienceUrl;
            } else {
                response.json().then( async ( data ) => {
                    if ( data.location ) {
                        window.location.href = data.location;
                    } else if ( !data.success ) {
                        if ( data.error === 'id.error.lockedUserCredentials' ) {
                            dispatch( setError( [ { code: 'login.error.softLockedAccount', message: 'login.error.softLockedAccountHeader', data: data?.error_details } ] ) );
                        } else if ( data.error === 'id.error.nonActivatedUser' ) {
                            dispatch( setError( [ { code: 'login.error.unactivatedAccount' } ] ) );
                        } else if ( data.error === 'id.error.inactiveUser' ) {
                            await handleInactiveTerminatedUser( data, companyId, dispatch );
                        } else if ( data.error === 'id.error.passwordExpired' ) {
                            dispatch( setError( [ { code: 'login.error.passwordExpired', message: 'login.error.passwordExpiredHeader', data: { ...data?.error_details, passwordRepeatLimit: PASSWORD_REPEAT_LIMIT  } } ] ) );
                            dispatch( setLoggedInPersonDetails( data?.error_details?.person, password ) );
                        } else if ( data.error === 'id.error.notFoundSession' ) {
                            sessionStorage.clear();
                            const primaryExperienceUrl = await dispatch( getPrimaryExperienceUrl() );
                            window.location = primaryExperienceUrl;
                        } else {
                            dispatch( setError( [ { code: 'login.error.invalidLogin' } ] ) );
                        }
                    } else {
                        dispatch( setError( [ { code: 'login.error.invalidLogin' } ] ) );
                    }
                } );
            }
        } ).catch( err => {
            dispatch( setError( [ { code: 'login.error.unknownError' } ] ) );
        } ).finally( () => {
            dispatch( endLoading() );
        } );
    };
}